<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="The First Dream—The Mountain and the Angel">
<h6 class="chno">4</h6>
<h1 class="chtitle">The Garden Where Eyes Are Opened</h1>
<p class="nonindent">He turned and walked slowly across the expansive carpet of green. I followed at his side. We continued some distance in silence.</p>
<p class="indent">“What is this place?” I asked at length.</p>
<p class="indent">He took no offense at my question. Indeed, once the words were out of my mouth, it came to me that in some mysterious fashion he may himself have prompted them.</p>
<p class="indent">“This is the Garden Where Eyes Are Opened,” the Lord replied.</p>
<p class="indent">“Am I in heaven?” I said, a little timidly.</p>
<p class="indent">He smiled.</p>
<p class="indent">“Perhaps,” was all he gave for answer. After a brief pause, he added, “It is always one of the first questions. But it cannot be answered until one’s eyes are opened.”</p>
<p class="indent">We walked on.</p>
<p class="indent">“But surely, this cannot be . . . hell?” I said. “It is too marvelous for that.”</p>
<p class="indent">“It seems beautiful, as indeed it is. But you are yet capable of beholding only the outer appearance of what you see. Much here is the fruit of your own honest-dreaming imagination. You may use other words to describe it once your eyes are opened to the truths the blossoms have to tell you.”</p>
<p class="indent">“Is this purgatory then?” I asked, surprised at my own question. In my past life I had not believed in a third alternative between heaven and hell.</p>
<p class="indent">“Varied are both the pathways and the destinations for those whom I meet in this garden, here at the edge of Beyond,” he answered enigmatically. “Much will be answered when your nostrils are attentive to the fragrances of the blooms. Then will your inner eyes apprehend the truths they represent.”</p>
<p class="indent">“Do both saints and sinners arrive here first, and then leave for heaven and hell later?”</p>
<p class="indent">“Everyone’s eyes must be opened, that they may see their Selves for what they are.” His voice was gentle, his countenance like a mother’s caring for her child. “Thus only may they perceive what <i>must</i> be their final destination.”</p>
<p class="indent">“Where is mine?” I asked.</p>
<p class="indent">“When your eyes begin to open,” he answered, “you will know.”</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch04.vue?3c1491f7